import React from "react";
import Sidebar from "./Sidebar";
import Feed from "./Feed";
import "./App.css";


function HomeScreen() {
    return (
        <><Sidebar /><Feed /></>
    )
}

export default HomeScreen
